import { ON_SERVER } from '../consts.js';
import getStore from '../store/index.js';
import { actions as networkActions } from '../store/state/network.js';

const store = getStore();

export class KappaApiError extends Error {}
export class KappaApiUnknownError extends Error {}

async function _handleError(res) {
  let json;
  try {
    json = await res.json();
  } catch {}

  if (json && json.message) {
    throw new KappaApiError(json.message);
  }

  throw new KappaApiUnknownError(res.status);
}

function _onResponse(res) {
  if (res.ok) {
    store.dispatch(networkActions.END());
    return res;
  } else {
    return _handleError(res);
  }
}

function _onError(error) {
  store.dispatch(networkActions.END());
  throw error;
}

export function _makeFetch(url, options) {
  store.dispatch(networkActions.START());

  if (ON_SERVER) {
    return new Promise();
  } else {
    return fetch(url, options).then(_onResponse).catch(_onError);
  }
}

export function _toJson(response) {
  return response.json();
}
